import React, { useEffect } from "react";

import {  useDispatch, useSelector } from "react-redux"
import { Alert, Button } from "react-bootstrap";

import { formatUTCString } from "../../../dateutils.js";
import { useParams } from "react-router-dom";
import { getNotificationDescription, getNotificationTitle, loadNotifications, markNotificationResolved, selectNotifications } from "../../store/notificationsSlice.js";

const PER_PAGE = 20;

// export default connect(state => ({
//     notifications: getNotifications(getPanelHwaddr(), true),
//     start: state.notifications.start,
//     end: state.notifications.end
// }), {
//     doLoadNotifications: (start = null, end = null) => loadNotifications(getPanelHwaddr(), start, end),
//     resolveNotification: markNotificationResolved
// })(NotificationsTab)

export const NotificationsTab = () => {


    const { hwaddr } = useParams();
    const notifications = useSelector(selectNotifications(hwaddr));

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadNotifications(hwaddr))
    }, [hwaddr]);

    if(notifications.length == 0)
    {
        return <Alert bsStyle="info" style={{ opacity: 0.7 }}>
            <h4>No Notifications Found</h4>
            <p>This panel has not yet generated any notifications requiring your attention.</p>
        </Alert>
    }
    return <div className="notifications-drawer">
        {notifications.slice(0, PER_PAGE)
            .map(ev => <Alert key={ev.id} bsStyle="danger" style={(ev.resolved_by == null ? null : { opacity: 0.7 })}>
                <h4>{getNotificationTitle(ev)}</h4>
                <p>{getNotificationDescription(ev)}</p>
                {ev.resolved_by == null ?
                    <div>
                        <Button bsStyle="danger" className="pull-right" onClick={()=>{
                            dispatch(markNotificationResolved(ev.id)).then(()=>{
                                //TODO: Switch to locally updating and relying on a websocket event to update.
                                // doLoadNotifications(start, end)
                            })
                        }} >Mark Resolved</Button>
                        <div style={{ clear: "both" }}></div>
                    </div>
                    :
                    <small>Resolved by: {ev.resolved_by} on {formatUTCString(ev.resolved_on)}</small>
                }
            </Alert>
            )}


    </div>
 
}